import React from "react";
import AuthContainer from "../../../components/AuthContainer.js";
import { Container, Typography } from "@mui/material";
import appcolors from "../../../constants/Colors.js";
import BackButton from "../../../components/BackButton";
import SignupForm from "./SignupForm.js";

const Signup = () => {
  return (
    <AuthContainer>
      <BackButton />
      <Container sx={{ maxWidth: "520px !important", mt: 6 }}>
        <Typography variant="auth_h1" component={"h1"}>
          Registration
        </Typography>
        <Typography variant="auth_body1" component={"p"} sx={{ mt: 0.5 }}>
          For the purpose of industry regulation, your details are required.
        </Typography>
        <SignupForm />
      </Container>
    </AuthContainer>
  );
};

export default Signup;
